import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';

import closeCross from 'assets/closeCross.svg';
import helpBubble from 'assets/helpBubble.svg';
import heyLogo from 'assets/heyLogo.svg';
import menuIcon from 'assets/menuIcon.svg';
import nhslogo from 'assets/nhs-providing.svg';
import { AUTH_LOGOUT } from '../../helpers/types';
import styles from './styles.module.css';

const Header = ({ noSignIn = false }) => {
  const authenticated = useSelector((state) => state.auth.authenticated);
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [showMenuVisible, setMenuVisible] = useState(false);

  const logout = () => {
    setMenuVisible(false);
    dispatch({ type: AUTH_LOGOUT });
    history.push('/pharmacy/login');
  };

  const showMenu = () => {
    setMenuVisible(!showMenuVisible);
  };

  const showSignIn = () => {
    const checkRoutes = ['/pharmacy/login', '/pharmacy/login/email', '/pharmacy/login/mobile', '/pharmacy'];
    var path = pathname;
    path = path.replace(/\/\d*$/, '');
    return !checkRoutes.includes(path);
  };

  const showRegister = () => {
    const checkRoutes = ['/pharmacy/register'];
    var path = pathname;
    path = path.replace(/\/\d*$/, '');
    return !checkRoutes.includes(path);
  };

  const signInDisplay = () => {
    if (!!authenticated) {
      return null;
    } else {
      return (
        <>
          <div className={styles.authedControlsWeb}>
            <div className={styles.logoContainer}>
              <img className={styles.nhsLogo} src={nhslogo} alt="providing NHS services badge" />
            </div>
            {showSignIn() ? (
              <>
                <div className={styles.headerVrContainer}>
                  <div className={styles.headerVr} />
                </div>
                <Link className={styles.headerLink} to="/pharmacy/login">
                  <button className="coop-btn coop-btn--tertiary">Sign in</button>
                </Link>
              </>
            ) : null}
            {showRegister() ? (
              <>
                <div className={styles.headerVrContainer}>
                  <div className={styles.headerVr} />
                </div>
                <Link className={styles.headerLink} to="/pharmacy/register">
                  <button className="coop-btn coop-btn--secondary">Register</button>
                </Link>
              </>
            ) : null}
          </div>
          <div className={styles.authedControlsMobile} onClick={() => showMenu()}>
            <img className={styles.menuIcon} src={menuIcon} alt="Menu icon" />
          </div>
        </>
      );
    }
  };

  const signedInHeaderDisplay = () => {
    return (
      <>
        <div className={styles.authedControlsWeb}>
          <a
            tabIndex="0"
            href="https://intercom-help.eu/heypharmacist/en"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.headerLink}>
            <img className={styles.helpIcon} src={helpBubble} alt={`Help and support`} />
            <div>Help & Support</div>
          </a>
          <div className={styles.headerVrContainer}>
            <div className={styles.headerVr} />
          </div>
          <Link tabIndex="0" className={styles.account} to="/pharmacy/dashboard/account">
            <div>My Account</div>
          </Link>
          <button type="button" className={`coop-t-link ${styles.logout}`} onClick={logout}>
            Sign Out
          </button>
        </div>
        <div className={styles.authedControlsMobile} onClick={() => showMenu()}>
          <img className={styles.menuIcon} src={menuIcon} alt="Menu icon" />
        </div>
      </>
    );
  };

  const menuDisplay = () => {
    return (
      <div className={styles.menuBackground} onClick={() => showMenu()}>
        <div
          className={styles.menu}
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <div className={styles.menuClose} onClick={() => showMenu()}>
            Close <img className={styles.menuCloseIcon} src={closeCross} alt={`Close menu`} />
          </div>
          <a
            tabIndex="0"
            href="https://intercom-help.eu/heypharmacist/en"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.headerLink}>
            <h2 className={styles.menuLinks}>Help & Support</h2>
          </a>
          {!!authenticated ? (
            <>
              <Link onClick={() => setMenuVisible(false)} className={styles.menuLinks} to="/pharmacy/dashboard/account">
                <h2 className={styles.menuLinks}>My Account</h2>
              </Link>
              <h2 className={styles.menuLinks} onClick={logout}>
                Sign out
              </h2>
            </>
          ) : (
            <Link onClick={() => setMenuVisible(false)} className={styles.menuLinks} to="/pharmacy/login">
              <h2 className={styles.menuLinks}>Sign in</h2>
            </Link>
          )}
        </div>
      </div>
    );
  };

  const logoDisplay = () => {
    return !!authenticated ? (
      <Link tabIndex="0" className={styles.coopLink} to="/pharmacy/dashboard">
        <img className={styles.heyLogo} src={heyLogo} alt="Hey Pharmacist logo" />
      </Link>
    ) : (
      <a tabIndex="0" className={styles.coopLink} href="/">
        <img className={styles.heyLogo} src={heyLogo} alt="Hey Pharmacist logo" />
      </a>
    );
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <div className={styles.headerGrid}>
          {logoDisplay()}
          {!noSignIn && signInDisplay()}
          {!!authenticated && signedInHeaderDisplay()}
        </div>
      </div>
      {showMenuVisible && menuDisplay()}
    </header>
  );
};

export default Header;
